import { Col, Row, Tabs } from "antd";
import { TaskHistory } from "components/Shared/TaskHistory";
import { TaskActions } from "components/TaskActions/TaskActions";

type Props = {
  entityId: string;
  isLoading: boolean;
  tabs: Array<any>;
  season?: any;
  fixture?: any;
  roster: Array<any>;
  staff: Array<any>;
};

export const TabsAndTaskHistory = ({ entityId, season, fixture, roster, staff, isLoading, tabs }: Props) => {
  const taskHistoryRecords = season?.taskHistoryRecords || fixture?.taskHistoryRecords || [];
  const tabsCols = taskHistoryRecords.length > 0 ? 20 : 24;
  const tabsStyle = taskHistoryRecords.length > 0 ? { paddingRight: 10 } : undefined;

  return (
    <Row>
      <Col span={tabsCols}>
        <Tabs style={tabsStyle} centered={true} defaultActiveKey="roster" items={tabs}></Tabs>
      </Col>
      {taskHistoryRecords.length > 0 && (
        <Col span={4}>
          <div
            className="mb-15"
            style={{
              display: "flex",
              justifyContent: "end",
              minHeight: "33px",
            }}
          >
            <TaskActions entityId={entityId} season={season} fixture={fixture} roster={roster} staff={staff} />
          </div>
          <TaskHistory taskHistoryRecords={taskHistoryRecords} isLoading={isLoading} />
        </Col>
      )}
    </Row>
  );
};
